import { Box, Button, Typography } from '@mui/material'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import { useTranslation } from 'react-i18next'

interface OfflineNoticeProps {
  onRetry?: () => void
}

/** Friendly full-section empty state for screens that need the network. */
export function OfflineNotice({ onRetry }: OfflineNoticeProps) {
  const { t } = useTranslation()
  return (
    <Box sx={{ textAlign: 'center', py: 8, px: 2 }}>
      <CloudOffIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        {t('offline.noticeTitle')}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 420, mx: 'auto' }}>
        {t('offline.noticeBody')}
      </Typography>
      {onRetry && (
        <Button variant="outlined" onClick={onRetry}>
          {t('offline.retry')}
        </Button>
      )}
    </Box>
  )
}
